<template>
  <!-- 应付 -->
  <div class="box-wrap">
    <el-form
      ref="addReceivable"
      :model="addDataInfo"
      :rules="rules"
      label-width="100px"
    >
      <!-- <column-box :column="2" labelWidth="100" v-if="addDataKeyList"> -->
      <!-- 内容 -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[2].key"
          :label="addDataKeyList[2].label + columnSeparator"
        >
          <el-select
            v-model="addDataInfo[addDataKeyList[2].key]"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in freeTypeList"
              :label="item.name"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 时间 -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[1].key"
          :label="addDataKeyList[1].label + columnSeparator"
        >
          <el-date-picker
            v-model="addDataInfo[addDataKeyList[1].key]"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择时间"
            clearable
          >
          </el-date-picker>
        </el-form-item>
      </el-col>

      <!-- 金额 -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[0].key"
          :label="addDataKeyList[0].label + columnSeparator"
        >
          <el-input
            v-number:money
            v-model="addDataInfo[addDataKeyList[0].key]"
            placeholder="请输入"
            class="width171"
            clearable
            maxlength="13"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
      </el-col>

      <!-- 车牌号 -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[6].key"
          :label="addDataKeyList[6].label + columnSeparator"
        >
          <CarSelect
            :modelValue="addDataInfo[addDataKeyList[6].key]"
            :getCarDetail="false"
            @update:modelValue="val => { addDataInfo[addDataKeyList[6].key] = val }"
            @change="carNoChange">
          </CarSelect>
        </el-form-item>
      </el-col>

      <!-- 付款方类型 -->
      <el-col :span="12">
        <el-form-item
          v-if="type === 1"
          :prop="addDataKeyList[8].key"
          :label="addDataKeyList[8].label + columnSeparator"
        >
          <el-select
            v-model="addDataInfo[addDataKeyList[8].key]"
            placeholder="请选择"
            clearable
            @change="changeCustomerType"
          >
            <el-option
              v-for="item in payerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 收款方类型 -->
      <el-col :span="12">
        <el-form-item
          v-if="type === 2"
          :prop="addDataKeyList[8].key"
          :label="addDataKeyList[8].label + columnSeparator"
        >
          <el-select
            v-model="addDataInfo[addDataKeyList[8].key]"
            placeholder="请选择"
            clearable
            @change="changeCustomerType"
          >
            <el-option
              v-for="item in payerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 付款方 -->
      <el-col :span="12">
        <el-form-item
          v-if="type === 1"
          :prop="addDataKeyList[3].key"
          :label="addDataKeyList[3].label + columnSeparator"
        >
          <el-select
            v-model="addDataInfo[addDataKeyList[3].key]"
            filterable
            :placeholder="isCustomer ? '请先选择收款方类型' : '请输入关键词'"
            clearable
            :loading="loading"
            :remote="remoteAble"
            :remote-method="getPayCustomerList"
            :disabled="isCustomer"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 收款方付款方 -->
      <el-col :span="12">
        <el-form-item
          v-if="type === 2"
          :prop="addDataKeyList[3].key"
          :label="addDataKeyList[3].label + columnSeparator"
        >
          <el-select
            v-model="addDataInfo[addDataKeyList[3].key]"
            :disabled="isCustomer"
            filterable
            :placeholder="isCustomer ? '请先选择收款方类型' : '请输入关键词'"
            clearable
            :loading="loading"
            :remote="remoteAble"
            :remote-method="getPayCustomerList"
            @change="handleCustomerIdChange"
          >
            <el-option
              v-for="item in customerList"
              :key="item.id"
              :label="item.customerName"
              :value="item.id"
            >
              <CustomerNameOptionItem :data="item" />
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 来源类型 -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[4].key"
          :label="addDataKeyList[4].label + columnSeparator"
        >
          <el-select
            v-model="addDataInfo[addDataKeyList[4].key]"
            placeholder="请选择"
            @change="changeSourceOrderType"
            clearable
            :disabled="isSourceOrderType"
          >
            <el-option
              v-for="item in sourceOrderTypeList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 来源单ID -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[5].key"
          :label="addDataKeyList[5].label + columnSeparator"
        >
          <el-select
            :disabled="isSourceOrder"
            maxlength="19"
            :placeholder="
              isSourceOrder ? '请先选择来源单类型' : '请选择来源单号'
            "
            v-model="addDataInfo[addDataKeyList[5].key]"
            clearable
            filterable
          >
            <el-option
              v-for="item in sourceOrderIdList"
              :label="item"
              :value="item"
              :key="item"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- 备注 -->
      <el-col :span="12">
        <el-form-item
          :prop="addDataKeyList[7].key"
          :label="addDataKeyList[7].label + columnSeparator"
          class="textare205"
        >
          <el-input
            v-model="addDataInfo.remarks"
            type="textarea"
            placeholder="请输入内容"
            maxlength="500"
            show-word-limit
            clearable
          >
          </el-input>
        </el-form-item>
      </el-col>

      <!-- </column-box> -->
    </el-form>
  </div>
</template>

<script>
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { getCollectCustomerList, getSourceOrderId } from '@/api/financeApi'
import CustomerNameOptionItem from '@/components/CustomerSelect/optionItem'
import selectOption from '@/store/dict/selectOptionDict'
import { limitMoreZero } from '@/utils/validate'
import { mapState } from 'vuex'

export default {
  name: 'addReceivable',
  props: {
    type: {
      type: Number,
      default: 1,
    },
    // eslint-disable-next-line vue/no-unused-properties
    payeeTypeList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CustomerNameOptionItem,
  },
  data() {
    return {
      // isSourceOrder: true, // 来源单是否禁用
      isCustomer: true, // 付款方是否禁用
      // eslint-disable-next-line vue/no-unused-properties
      sourceOrderTypeDict: selectOption.sourceOrderTypeDict,
      // eslint-disable-next-line vue/no-unused-properties
      completionStatusDict: selectOption.completionStatusDict,
      loading: false,
      // eslint-disable-next-line vue/no-unused-properties
      formLabelAlign: {
        plateNo: '',
      },
      // eslint-disable-next-line vue/no-unused-properties
      receivablePay: {},
      addDataInfo: {
        receivableAmount: '',
        receivableDate: '',
        content: '',
        customerId: '',
        sourceOrderType: '',
        sourceOrderId: '',
        carId: '',
        remarks: '',
        payeeType: '',
      },
      customerList: [], // 模糊搜索付款客户收款客户
      // eslint-disable-next-line vue/no-unused-properties
      keys: [{}],
      // eslint-disable-next-line vue/no-unused-properties
      textarea: '',
      isPayeeType: true,
      sourceOrderIdList: [], // 来源单号列表
    }
  },
  watch: {
    type: {
      handler(val) {
        if (val === 2) {
          const obj = {
            payAmount: '',
            payDate: '',
            payType: '',
            payeeId: '',
            sourceOrderType: '',
            sourceOrderId: '',
            carId: '',
            payState: '',
            remarks: '',
            payeeType: '',
          }
          this.addDataInfo = obj
        }
      },
      immediate: true,
    },
    addDataInfo: {
      handler(val) {
        this.isPayeeType = val.payeeType !== 1
      },
      deep: true,
    },
    isSourceOrderType() {
      this.addDataInfo[this.addDataKeyList[5].key] = ''
      this.sourceOrderIdList = []
    },
  },
  computed: {
    ...mapState({
      freeTypeList(state) {
        return state.global.freeTypeList.filter((item) => {
          // 应收和应付均需过滤掉“租金退款” 司机应收 支付总金额
          return item.code !== 34 && item.code !== 44 && item.code !== 45
        })
      }, // 收款项
    }),
    remoteAble() {
      const { customerType, payeeType } = this.addDataInfo
      return `${customerType}` === '2' || `${payeeType}` === '2'
    },
    // 来源单是否禁用
    isSourceOrder() {
      const value = this.addDataInfo[this.addDataKeyList[4].key]
      const status = value === 100 || value === ''
      return status
    },
    isSourceOrderType() {
      const carId = this.addDataInfo[this.addDataKeyList[6].key]
      const customerType = this.addDataInfo[this.addDataKeyList[8].key]
      const customerId = this.addDataInfo[this.addDataKeyList[3].key]

      return !carId || !customerType || !customerId
    },
    // 付款方类型枚举
    payerList() {
      const result = {}
      for (const key in selectOption.customerTypeDict) {
        if (Object.hasOwnProperty.call(selectOption.customerTypeDict, key)) {
          if (Number(key) !== 10) {
            result[key] = selectOption.customerTypeDict[key]
          }
        }
      }
      return this.dictParseList(result)
    },
    // 完成状态列表
    // eslint-disable-next-line vue/no-unused-properties
    completionStatusList() {
      return this.dictParseList(selectOption.completionStatusDict)
    },

    // 来源单类型
    sourceOrderTypeList() {
      return this.dictParseList(selectOption.sourceOrderTypeDict)
    },
    // 添加应收应付字段不一样
    // eslint-disable-next-line vue/return-in-computed-property
    addDataKeyList() {
      if (this.type === 1) {
        return [
          {
            key: 'receivableAmount',
            label: '应收金额',
          },
          {
            key: 'receivableDate',
            label: '应收日期',
          },
          {
            key: 'content',
            label: '收款内容',
          },
          {
            key: 'customerId',
            label: '付款方',
          },
          {
            key: 'sourceOrderType',
            label: '来源类型',
          },
          {
            key: 'sourceOrderId',
            label: '来源单号',
          },
          {
            key: 'carId',
            label: '车牌号',
          },
          {
            key: 'remarks',
            label: '备注',
          },
          {
            key: 'customerType',
            label: '付款方类型',
          },
        ]
      } else if (this.type === 2) {
        return [
          {
            key: 'payAmount',
            label: '应付金额',
          },
          {
            key: 'payDate',
            label: '应付日期',
          },
          {
            key: 'payType',
            label: '应付内容',
          },
          {
            key: 'payeeId',
            label: '收款方',
          },
          {
            key: 'sourceOrderType',
            label: '来源类型',
          },
          {
            key: 'sourceOrderId',
            label: '来源单号',
          },
          {
            key: 'carId',
            label: '车牌号',
          },
          {
            key: 'remarks',
            label: '备注',
          },
          {
            key: 'payeeType',
            label: '收款方类型',
          },
        ]
      }
    },
    // 因为字段不一样，所以区分开
    // eslint-disable-next-line vue/return-in-computed-property
    rules() {
      // 应收/应付校验不能为0
      const amountRules = (rule, value, callback) => {
        const text = this.type === 1 ? '应收' : '应付'
        let v = null
        limitMoreZero(value, (data) => {
          v = data
        })
        if (v === 0) {
          callback(new Error(`${text}金额不能为0`))
        } else {
          callback()
        }
      }
      if (this.type === 1) {
        return {
          // 来源单号
          sourceOrderId: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          // 付款方
          customerId: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          // 付款方类型
          customerType: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          // 应收内容
          content: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          // 应收
          receivableAmount: [
            { validator: amountRules, trigger: 'blur' },
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          receivableDate: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          sourceOrderType: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          carId: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
        }
      }

      // 应付
      if (this.type === 2) {
        return {
          // 来源单号
          sourceOrderId: [
            {
              required: true,
              message: '来源单号不能为空',
              trigger: 'change',
            },
          ],
          // 收款方
          payeeId: [
            {
              required: true,
              message: '收款方不能为空',
              trigger: 'change',
            },
          ],
          // 收款方类型
          payeeType: [
            {
              required: true,
              message: '收款方类型不能为空',
              trigger: 'change',
            },
          ],
          // 车牌号
          carId: [
            {
              required: true,
              message: '车牌号不能为空',
              trigger: 'change',
            },
          ],
          // 应付内容
          payType: [
            {
              required: true,
              message: '应付内容不能为空',
              trigger: 'change',
            },
          ],
          payAmount: [
            { validator: amountRules, trigger: 'blur' },
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          payDate: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
          sourceOrderType: [
            {
              required: true,
              message: '不能为空',
              trigger: 'change',
            },
          ],
        }
      }
    },
  },
  methods: {
    // 来源方类型选中
    changeSourceOrderType(val) {
      if (val === 100 || val === '') {
        // this.isSourceOrder = true
        delete this.rules.sourceOrderId
        this.addDataInfo[this.addDataKeyList[5].key] = '' // 来源单号清空
      } else {
        // this.isSourceOrder = false
        this.rules.sourceOrderId = [
          {
            required: true,
            message: '不能为空',
            trigger: 'change',
          },
        ]
        this.getSourceOrderId()
      }
    },
    // 付款方选中类型
    changeCustomerType(val) {
      // 类型为其他-付款方禁用，不可填写
      if (val === 10 || val === '') {
        this.isCustomer = true
        delete this.rules.customerId
        delete this.rules.payeeId
      } else {
        this.isCustomer = false
        this.rules.customerId = [
          {
            required: true,
            message: '不能为空',
            trigger: 'change',
          },
        ]
        this.rules.payeeId = [
          {
            required: true,
            message: '不能为空',
            trigger: 'change',
          },
        ]
      }

      // 选择类型 清空收付款方的数据
      if (this.type === 1) {
        this.addDataInfo.customerId = ''
      } else {
        this.addDataInfo.payeeId = ''
      }
      this.addDataInfo[this.addDataKeyList[4].key] = '' // 来源单类型清空
      this.customerList = []
      this.getCustomerHandle()
    },
    getCustomerHandle() {
      const { customerType, payeeType } = this.addDataInfo
      //  服务商
      if (`${customerType}` === '1' || `${payeeType}` === '1') {
        this.getCollectCustomerList()
      } else {
        this.getPayCustomerList()
      }
    },
    // 模糊搜索获取收款方
    async getCollectCustomerList() {
      // 开启远程搜索
      this.loading = true
      getCollectCustomerList().then(({ code, data }) => {
        if (code === 1) {
          this.customerList = data.items.map((item) => ({
            ...item,
            customerName: item.name,
            customerTel: item.contactTel,
          }))
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // 收/付款方
    async getPayCustomerList(query) {
      this.customerList = []
      // 开启远程搜索
      this.loading = true
      searchByCustomerNameSensitive({
        customerState: 1,
        customerName: query,
        mixedType: 'YES',
      }).then(({ code, data }) => {
        if (code === 1) {
          this.customerList = data
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // ./payable.vue有引用
    // eslint-disable-next-line vue/no-unused-properties
    formValidate() {
      return new Promise((resolve, reject) => {
        this.$refs.addReceivable.validate((valid) => {
          if (valid) {
            resolve(this.addDataInfo)
          } else {
            reject()
          }
        })
      })
    },
    // eslint-disable-next-line vue/no-unused-properties
    formResetFields() {
      this.$refs.addReceivable.resetFields()
      this.addDataInfo.customerType = ''
      this.isCustomer = true
    },
    // 获取来源单号
    async getSourceOrderId() {
      this.addDataInfo.sourceOrderId = ''
      this.sourceOrderIdList = []
      // 来源单号
      this.addDataInfo[this.addDataKeyList[5].key] = ''
      if (
        !this.addDataInfo[this.addDataKeyList[6].key] ||
        !this.addDataInfo[this.addDataKeyList[4].key] ||
        !this.addDataInfo[this.addDataKeyList[3].key]
      ) {
        return
      }
      const para = {
        carId: this.addDataInfo[this.addDataKeyList[6].key], // 车牌号id
        sourceOrderType: this.addDataInfo[this.addDataKeyList[4].key], // 来源单类型
      }
      const { customerType, payeeType } = this.addDataInfo
      //  服务商
      if (`${customerType}` === '1' || `${payeeType}` === '1') {
        para.providerId = this.addDataInfo[this.addDataKeyList[3].key]
      }
      // 客户
      if (`${customerType}` === '2' || `${payeeType}` === '2') {
        para.customerId = this.addDataInfo[this.addDataKeyList[3].key]
      }

      const { data } = await getSourceOrderId(para)
      this.sourceOrderIdList = data || []
    },
    handleCustomerIdChange() {
      this.addDataInfo.sourceOrderId = ''
      this.addDataInfo[this.addDataKeyList[4].key] = '' // 来源单类型清空
    },
    // 车牌号改变
    carNoChange(value) {
      if (!value) {
        // this.isSourceOrder = true
        this.addDataInfo[this.addDataKeyList[4].key] = '' // 来源单类型清空
      }
      this.getSourceOrderId()
    },
  },
}
</script>

<style scoped lang="scss">
.box-wrap {
  ::v-deep .el-input--small {
    width: 205px;
  }
}
.customer {
  display: flex;
  flex-direction: row;
  &-name {
    // float: left;
    width: 80px;
    height: 35px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
  }
  &-phone {
    // float: left;
    color: #8492a6;
    font-size: 13px;
    margin: 0;
    padding-left: 20px;
  }
}
</style>
